import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./Slices/authSlice";
import profileReducer from "./Slices/ProfileSlice";
import servicesCategoriesReducr from "./Slices/ServiceCategoriesSlice";
import CompensationCategoriesSlice from "./Slices/CompensationCategoriesSlice";
import FleetRequestTypeSlice from "./Slices/FleetRequestTypeSlice";
import SuppliersSlice from "./Slices/SuppliersSlice";
import CompanyManagementsSlice from "./Slices/CompanyManagementsSlice";
import countriesReducer from "./Slices/CountriesSlice";
import regionReducer from "./Slices/RegionSlice";
import CityReducer from "./Slices/CitiesSlice";
import googleMapLinksReducer from "./Slices/GoogleMapLinksSlice";
import positionsReducer from "./Slices/PositionsSlice";
import officeReducer from "./Slices/OfficesSlice";
import FleetManagementTypesSlice from "./Slices/FleetManagementTypesSlice";
import FileArchiveTypeSlice from "./Slices/FileArchiveTypeSlice";
import VehicleCompaniesSlice from "./Slices/VehicleCompaniesSlice";
import OrderIssueTypesSlice from "./Slices/OrderIssueTypesSlice";
import JobsSlice from "./Slices/JobsSlice";
import OfficeDocumentTypeSlice from "./Slices/OfficeDocumentTypeSlice";
import DocumentTypeSlice from "./Slices/DocumentTypeSlice";
import AttachmentTypesSlice from "./Slices/AttachmentTypesSlice"; 
import SalesAccountsSlice from "./Slices/SalesAccountsSlice"; 
import SalesReturnsAccountsSlice from "./Slices/SalesReturnsAccountsSlice"; 
import RelatedPartyAccountsSlice from "./Slices/RelatedPartyAccountsSlice"; 
import PurchasesAccountsSlice from "./Slices/PurchasesAccountsSlice"; 
import PurchaseReturnsAccountsSlice from "./Slices/PurchaseReturnsAccountsSlice"; 
import EmployeesSlice from "./Slices/EmployeesSlice"; 
import FAQsSlice from "./Slices/FAQsSlice"; 
import ClientsSlice from "./Slices/ClientsSlice"; 
import BanksSlice from "./Slices/BanksSlice"; 
import BusinessSectorSlice from "./Slices/BusinessSectorSlice"; 
import ServiceTypesSlice from "./Slices/ServiceTypesSlice"; 
import QuotationFeaturesSlice from "./Slices/QuotationFeaturesSlice"; 
import LoadTypesSlice from "./Slices/LoadTypesSlice"; 
import GoodTypesSlice from "./Slices/GoodTypesSlice"; 
import CarDepartmentsSlice from "./Slices/CarDepartmentsSlice"; 
import MainSettingsSlice from "./Slices/MainSettingsSlice"; 
import FurnitureQuestionsSlice from "./Slices/FurnitureQuestionsSlice"; 
import CategoryRushHoursSlice from "./Slices/CategoryRushHoursSlice"; 
import ChartAccountsSlice from "./Slices/ChartAccountsSlice"; 
import EasyEntriesSlice from "./Slices/EasyEntriesSlice";
import ManualJournalEntriesSlice from "./Slices/ManualJournalEntriesSlice"; 
import TripwayBranchesSlice from "./Slices/TripwayBranchesSlice"; 
import PermissionsSlice from "./Slices/PermissionsSlice"; 
import RolesSlice from "./Slices/RolesSlice"; 
import BusinessSectorUsersSlice from "./Slices/BusinessSectorUsersSlice"; 
import BusinessSectorResponsiblesSlice from "./Slices/BusinessSectorResponsiblesSlice"; 
import BusinessSectorCreditsSlice from "./Slices/BusinessSectorCreditsSlice"; 
import BusinessSectorDocsSlice from "./Slices/BusinessSectorDocsSlice"; 
import BusinessSectorContractsSlice from "./Slices/BusinessSectorContractsSlice"; 
import FavoritesSlice from "./Slices/FavoritesSlice"; 
import ExportOrdersSlice from "./Slices/ExportOrdersSlice"; 
import ExceededCommissionAccountsSlice from "./Slices/ExceededCommissionAccountsSlice"; 
import DriversSlice from "./Slices/DriversSlice"; 
import TripwayPartnersSlice from "./Slices/TripwayPartnersSlice"; 
import VehiclesSlice from "./Slices/VehiclesSlice";
import FleetManagementMaintenanceSlice from "./Slices/FleetManagementMaintenanceSlice";
import FuelSlice from "./Slices/FuelSlice";
import EntriesSlice from "./Slices/EntriesSlice";

import LeasingMaintenanceSlice from "./Slices/LeasingMaintenanceSlice";
import LeasingFuelSlice from "./Slices/LeasingFuelSlice";
import LeasingEntriesSlice from "./Slices/LeasingEntriesSlice";

import CountriesCitiesSlice from './Slices/CountriesAndCitiesSlice';
import PurchaseOrdersSlice from './Slices/PurchaseOrdersSlice';
import RentalMainProjectsSlice from './Slices/RentalMainProjectsSlice';
import QuotationRequestCustomersSlice from './Slices/QuotationRequestCustomersSlice';
import QuotationRequestsSlice from './Slices/QuotationRequestsSlice';
import QuotationRequestSuppliersSlice from './Slices/QuotationRequestSuppliersSlice';
import TransportDocumentsSlice from './Slices/TransportDocumentsSlice';
import TripRequestsSlice from './Slices/TripRequestsSlice';
import ManualGroupedOrdersSlice from './Slices/ManualGroupedOrdersSlice';

import RentalMainOrdersSlice from './Slices/RentalMainOrdersSlice';
import EstablishmentDocumentsSlice from './Slices/EstablishmentDocumentsSlice';
import BondsSlice from './Slices/BondsSlice';
import SalesInvoiceSlice from './Slices/SalesInvoiceSlice';
import PurchaseInvoicesSlice from './Slices/PurchaseInvoicesSlice';
import DebitNotesSlice from './Slices/DebitNotesSlice';
import CreditNotesSlice from './Slices/CreditNotesSlice';
import EmployeeDocumentSlice from './Slices/EmployeeDocumentSlice';
import VehicleDocumentSlice from "./Slices/VehicleDocumentSlice";
import DriverDocumentsSlice from "./Slices/DriverDocumentsSlice";
import FleetMandatesSlice from "./Slices/FleetMandatesSlice";
import RentalMainContractsSlice from "./Slices/RentalMainContractsSlice";
import WinchPartnersSlice from "./Slices/WinchPartnersSlice";
import CostCenterAccountsSlice from "./Slices/CostCenterAccountsSlice";
import WinchPartnerDocumentsSlice from "./Slices/WinchPartnerDocumentsSlice";
import WinchPartnerContractsSlice from "./Slices/WinchPartnerContractsSlice";
import TeamworkMovementsSlice from "./Slices/TeamworkMovementsSlice";
import TargetCustomersSlice from "./Slices/TargetCustomersSlice";
import LeadsSlice from "./Slices/LeadsSlice";
import TravelRequestCompensationsSlice from "./Slices/TravelRequestCompensationsSlice";
const store = configureStore({
  reducer: {
    auth: authReducer,
    profile: profileReducer,
    servicesCategories: servicesCategoriesReducr,
    compensationCategories: CompensationCategoriesSlice,
    travelRequestCompensations: TravelRequestCompensationsSlice,
    fleet_request_types: FleetRequestTypeSlice,
    suppliers: SuppliersSlice,
    company_managements: CompanyManagementsSlice,
    countries: countriesReducer,
    regions: regionReducer,
    cities: CityReducer,
    GoogleMapLinks: googleMapLinksReducer,
    positions: positionsReducer,
    offices: officeReducer,
    fleet_request_types: FleetManagementTypesSlice,
    file_archive_types: FileArchiveTypeSlice,
    vehicle_companies: VehicleCompaniesSlice,
    order_issue_types: OrderIssueTypesSlice,
    job_company_managements: JobsSlice,
    office_document_types: OfficeDocumentTypeSlice,
    document_type: DocumentTypeSlice,
    attachment_types: AttachmentTypesSlice,
    sales_accounts: SalesAccountsSlice,
    sales_returns_accounts: SalesReturnsAccountsSlice,
    related_party_accounts: RelatedPartyAccountsSlice,
    purchases_accounts: PurchasesAccountsSlice,
    purchase_returns_accounts: PurchaseReturnsAccountsSlice,
    employees: EmployeesSlice,
    faqs: FAQsSlice,
    clients: ClientsSlice,
    banks: BanksSlice,
    businessSector: BusinessSectorSlice,
    serviceTypes:ServiceTypesSlice,
    quotationFeatures:QuotationFeaturesSlice,
    loadTypes:LoadTypesSlice,
    goodTypes:GoodTypesSlice,
    car_departments:CarDepartmentsSlice,
    main_settings:MainSettingsSlice,
    furniture_questions:FurnitureQuestionsSlice,
    category_rush_hours:CategoryRushHoursSlice,
    chart_accounts:ChartAccountsSlice,
    easy_entries:EasyEntriesSlice,
    manual_journal_entries: ManualJournalEntriesSlice,
    tripway_branches:TripwayBranchesSlice,
    permissions:PermissionsSlice,
    roles:RolesSlice,
    business_sector_users:BusinessSectorUsersSlice,
    business_sector_responsibles:BusinessSectorResponsiblesSlice,
    business_sector_credits: BusinessSectorCreditsSlice,
    business_documents: BusinessSectorDocsSlice,
    business_sector_contracts: BusinessSectorContractsSlice,
    favorites: FavoritesSlice,
    export_orders: ExportOrdersSlice,
    exceeded_commission_accounts: ExceededCommissionAccountsSlice,
    drivers: DriversSlice,
    tripway_partners: TripwayPartnersSlice,
    vehicles: VehiclesSlice,
    rental_management_maintenance: FleetManagementMaintenanceSlice,
    fuel: FuelSlice,
    entries: EntriesSlice,
    leasing_maintenance: LeasingMaintenanceSlice,
    leasing_fuel: LeasingFuelSlice,
    leasing_entries: LeasingEntriesSlice,
    countries_cities: CountriesCitiesSlice,
    purchase_orders: PurchaseOrdersSlice,
    rental_projects_main: RentalMainProjectsSlice,
    quotationRequestCustomers: QuotationRequestCustomersSlice,
    quotationRequests: QuotationRequestsSlice,
    quotationRequestSuppliers: QuotationRequestSuppliersSlice,
    transportDocuments: TransportDocumentsSlice,
    tripRequests: TripRequestsSlice,
    manualGroupedOrders: ManualGroupedOrdersSlice,
    rental_orders_main: RentalMainOrdersSlice,
    establishment_documents: EstablishmentDocumentsSlice,
    bonds: BondsSlice,
    sales_invoices: SalesInvoiceSlice,
    purchase_invoices: PurchaseInvoicesSlice,
    debit_notes: DebitNotesSlice,
    credit_notes: CreditNotesSlice,
    employee_document: EmployeeDocumentSlice,
    driver_documents: DriverDocumentsSlice,
    vehicle_document: VehicleDocumentSlice,
    fleet_mandates: FleetMandatesSlice,
    rental_contracts_main: RentalMainContractsSlice,
    winch_partners: WinchPartnersSlice,
    cost_center_accounts: CostCenterAccountsSlice,
    winch_partner_documents: WinchPartnerDocumentsSlice,
    winch_partner_contracts: WinchPartnerContractsSlice,
    teamwork_movements: TeamworkMovementsSlice,
    target_customers: TargetCustomersSlice,
    leads: LeadsSlice,
  },
});

export default store;
